<template>
  <div class="mx-10">
    <v-tabs v-model="activeTab" color="#00B3FF">
      <v-tab v-if="hasPermission('setting.company_settings')"
        >Company Settings</v-tab
      >
      <v-tab v-if="hasPermission('setting.project_settings')"
        >Project Settings</v-tab
      >
      <v-tab v-if="hasPermission('setting.project_settings')"
        >Project Dynamic Fields</v-tab
      >
      <v-tab-item :style="{ border: '1px solid var(--primary-boarder-color)' }">
        <CompanySettings v-if="hasPermission('setting.company_settings')" />
      </v-tab-item>
      <v-tab-item :style="{ border: '1px solid var(--primary-boarder-color)' }">
        <ProjectSettings v-if="hasPermission('setting.project_settings')" />
      </v-tab-item>
      <v-tab-item :style="{ border: '1px solid var(--primary-boarder-color)' }">
        <DynamicFields v-if="hasPermission('setting.project_settings')" />
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
import CompanySettings from "@/components/settings/CompanySettings";
import ProjectSettings from "@/components/settings/ProjectSettings";
import DynamicFields from "@/components/projects/DynamicFields";
const { mapGetters } = createNamespacedHelpers("auth");
import { createNamespacedHelpers } from "vuex";

export default {
  name: "Setting",
  components: {
    CompanySettings,
    ProjectSettings,
    DynamicFields,
  },
  data() {
    return {
      activeTab: 0,
    };
  },
  computed: {
    ...mapGetters({
      loading: "loading",
      profile: "profile",
      hasPermission: "hasPermission",
    }),
  },
  mounted() {
    this.$store.dispatch("auth/getProfile");
  },
};
</script>
